<template>
  <div class="shop-info">
    <!-- 表单 -->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="180px">
      <div class="common-form">商家基本信息</div>
      
      <!-- 商家头像 -->
      <el-form-item label="商家头像" prop="avatar">
        <div class="image-upload-wrapper">
          <div class="image-preview" v-if="form.avatar">
            <img :src="form.avatar" class="preview-image" />
            <div class="image-actions">
              <i class="el-icon-delete" @click="deleteImage('avatar')"></i>
            </div>
          </div>
          <div class="upload-placeholder" @click="openImageUpload('avatar')" v-else>
            <i class="el-icon-plus"></i>
            <div>上传头像</div>
          </div>
        </div>
        <p class="tc gray9">建议尺寸200x200</p>
      </el-form-item>

      <!-- 商家名称 -->
      <el-form-item label="商家名称" prop="shop_name">
        <el-input v-model="form.shop_name" placeholder="请输入商家名称" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- 商家地址 -->
      <el-form-item label="商家地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- 联系电话 -->
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入联系电话" class="max-w460">
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>

      <!-- 商家介绍 -->
      <div class="common-form">商家介绍</div>
      <el-form-item label="商家介绍">
        <div class="edit_container">
          <Uediter v-model="form.description" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>

      <!-- 商家服务 -->
      <div class="common-form">商家服务</div>
      <el-form-item label="服务项目">
        <div class="services-section">
          <el-checkbox-group v-model="form.services">
            <div class="service-checkboxes">
              <el-checkbox label="free_delivery">免费配送</el-checkbox>
              <el-checkbox label="quality_guarantee">品质保证</el-checkbox>
              <el-checkbox label="fresh_flowers">新鲜花材</el-checkbox>
              <el-checkbox label="custom_design">定制设计</el-checkbox>
              <el-checkbox label="fast_delivery">快速配送</el-checkbox>
              <el-checkbox label="after_sales">售后服务</el-checkbox>
            </div>
          </el-checkbox-group>
          
          <!-- 自定义服务 -->
          <div class="custom-services">
            <div class="service-input-wrapper" v-for="(service, index) in form.custom_services" :key="index">
              <el-input
                v-model="service.name"
                class="max-w460"
                placeholder="请输入自定义服务项目"
                style="margin-bottom: 10px;">
                <el-button slot="append" icon="el-icon-delete" @click="removeCustomService(index)"></el-button>
              </el-input>
            </div>
            <el-button type="text" icon="el-icon-plus" @click="addCustomService">添加自定义服务</el-button>
          </div>
        </div>
      </el-form-item>

      <!-- 营业时间 -->
      <el-form-item label="营业时间">
        <el-time-picker
          v-model="form.business_hours"
          is-range
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择营业时间"
          value-format="HH:mm"
          class="max-w460">
        </el-time-picker>
      </el-form-item>
    
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="onReset">重置</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">保存设置</el-button>
      </div>
    </el-form>
    
    <!-- 图片上传组件 -->
    <Upload 
      v-if="isProductUpload" 
      :config="{ total: 1 }" 
      :isupload="isProductUpload" 
      @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>
</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import Uediter from '@/components/UE.vue';

  export default {
    components: {
      Upload,
      Uediter
    },
    data() {
      return {
        /*是否上传图片*/
        isProductUpload: false,
        currentUploadField: '', // 当前上传的字段
        
        /*富文本配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
        
        /*form表单数据*/
        form: {
          avatar: '', // 商家头像
          avatar_id: '', // 头像文件ID
          shop_name: '', // 商家名称
          address: '', // 商家地址
          phone: '', // 联系电话
          description: '', // 商家介绍
          services: [], // 商家服务
          custom_services: [], // 自定义服务
          business_hours: ['09:00', '18:00'], // 营业时间
          delivery_range: '' // 配送范围
        },
        loading: false,
        
        /*验证规则*/
        rules: {
          shop_name: [
            { required: true, message: '请输入商家名称', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入商家地址', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ]
        }
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        // 获取商家信息
        SettingApi.shopInfoDetail({}, true)
          .then(data => {
            let shopInfo = data.data;
            self.form.avatar = shopInfo.avatar || '';
            self.form.avatar_id = shopInfo.avatar_id || '';
            self.form.shop_name = shopInfo.shop_name || '';
            self.form.address = shopInfo.address || '';
            self.form.phone = shopInfo.phone || '';
            self.form.description = shopInfo.description || '';
            self.ueditor.text = self.form.description;
            self.form.services = shopInfo.services || [];
            self.form.custom_services = shopInfo.custom_services || [];
            self.form.business_hours = shopInfo.business_hours || ['09:00', '18:00'];
            self.form.delivery_range = shopInfo.delivery_range || '';
          })
          .catch(error => {
            console.error('获取商家信息失败:', error);
          });
      },
      
      /*打开图片上传*/
      openImageUpload(field) {
        this.currentUploadField = field;
        this.isProductUpload = true;
      },

      /*删除图片*/
      deleteImage(field) {
        this.form[field] = '';
        this.form[field + '_id'] = '';
      },

      /*上传图片*/
      returnProductImgsFunc(e) {
        if (e != null && e.length > 0) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1].toLowerCase();
            imgExpt.forEach((imgExt) => {
              if (imgExt === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          // 根据当前上传的字段设置对应的数据
          if (this.currentUploadField === 'avatar') {
            this.form.avatar_id = e[0].file_id;
            this.form.avatar = e[0].file_path;
          }
        }
        
        this.isProductUpload = false;
        this.currentUploadField = '';
      },
      
      // 添加自定义服务
      addCustomService() {
        this.form.custom_services.push({ name: '' });
      },
      
      // 移除自定义服务
      removeCustomService(index) {
        this.form.custom_services.splice(index, 1);
      },
      
      // 提交表单
      onSubmit() {
        let self = this;
        
        self.$refs.form.validate(valid => {
          if (valid) {
            self.loading = true;
            
            // 过滤空的自定义服务
            const submitData = {
              ...this.form,
              description: this.$refs.ue.getUEContent(),
              custom_services: this.form.custom_services.filter(service => service.name.trim() !== '')
            };
            
            SettingApi.editShopInfo(submitData, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '商家信息保存成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
                self.$message.error('保存失败，请重试');
              });
          }
        });
      },
      
      // 重置表单
      onReset() {
        this.$confirm('确定要重置所有设置吗？', '提示', {
          type: 'warning'
        }).then(() => {
          this.getData(); // 重新获取原始数据
          this.$message({
            message: '重置成功',
            type: 'success'
          });
        }).catch(() => {});
      }
    }
  };
</script>

<style scoped>
  .shop-info {
    padding: 20px;
  }
  
  .max-w460 {
    max-width: 460px;
  }
  
  .common-form {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 15px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
  }
  
  .common-button-wrapper {
    margin-top: 30px;
    padding-left: 180px;
  }
  
  .tc {
    text-align: center;
  }
  
  .gray9 {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
  }
  
  /* 图片上传样式 */
  .image-upload-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  
  .image-preview {
    position: relative;
    width: 100px;
    height: 100px;
    margin-right: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .image-actions {
    position: absolute;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 4px;
    cursor: pointer;
    display: none;
  }
  
  .image-preview:hover .image-actions {
    display: block;
  }
  
  .upload-placeholder {
    width: 100px;
    height: 100px;
    border: 1px dashed #ddd;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #999;
  }
  
  .upload-placeholder:hover {
    border-color: #409eff;
    color: #409eff;
  }
  
  .upload-placeholder i {
    font-size: 24px;
    margin-bottom: 8px;
  }
  
  /* 服务项目样式 */
  .services-section {
    width: 100%;
  }
  
  .service-checkboxes {
    margin-bottom: 20px;
  }
  
  .service-checkboxes >>> .el-checkbox {
    margin-right: 30px;
    margin-bottom: 10px;
    min-width: 120px;
  }
  
  .custom-services {
    border-top: 1px solid #f0f0f0;
    padding-top: 20px;
  }
  
  .service-input-wrapper {
    margin-bottom: 10px;
  }
  
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>


// WEBPACK FOOTER //
// src/views/product/setting/flower.vue